export default __webpack_public_path__ + "static/media/res8.1c143a35.PNG";